const routes = [
  {
    path: '/news_feed',
    name: 'NewsFeedPage',
    meta: { label: '' },
    component: () => import('@/views/common/news-feed/index.vue')
  },
  {
    path: '/news_feed/news',
    name: 'NewsPage',
    meta: { label: '' },
    component: () => import('@/views/common/news-feed/News.vue')
  },
  {
    path: '/news_feed/news/:newsId',
    name: 'SelectedNews',
    meta: { label: '' },
    component: () => import('@/views/common/news-feed/SingleNews.vue')
  },
  {
    path: '/news_feed/events',
    name: 'EventsPage',
    meta: { label: '' },
    component: () => import('@/views/common/news-feed/Events.vue')
  },
  {
    path: '/news_feed/events/:eventId',
    name: 'SelectedEvent',
    meta: { label: '' },
    component: () => import('@/views/common/news-feed/SingleEvent.vue')
  }
]
export default routes
